export const ContactClassificationsEnum = {
    Developer: { key: 20712, value: 'Real State Developer' }
};
